// product_id, product_name, product_price, img_url
function create_product_card(product_id, product_name, product_price, base_price, on_sale, img_url, handle){
  
//   console.log(img_url)
  
//   let random_version = Math.random().toString(36).substr(2, 25)
  let today_date = new Date()
  let random_version = today_date.toDateString().replaceAll(" ","")
  let viewport_width = document.documentElement.clientWidth
  
  let width_divider = 2
  
  if (viewport_width > 768){
  		width_divider = 4
  }
  
  let img_width_raw = Math.round(viewport_width / width_divider) //image with fourth-third ratio and 80% of half of viewport width
  let img_width = Math.ceil(img_width_raw / 100) * 100

  
  var price_tag = ""
  
  if (on_sale == true){
  price_tag = 
    ` 
<span class="visually-hidden">Regular price</span>
<del class="grid-product__price--original">${base_price}</del>
<span class="visually-hidden">Sale price</span>
${product_price}
`
  }
  else
  {
	price_tag = product_price
  }
  
//   console.log(on_sale)
  
  
  let product_card = document.createElement("Div");

//   var product_id = "5408823541926";
//   var product_name = "Puffy";
//   var product_price = "RM58"
//   var img_url = "//cdn.shopify.com/s/files/1/0269/7225/8378/products/Puffy";
  
//   console.log(img_url)
  
  product_card.setAttribute("class", "grid__item grid-product small--one-half medium-up--one-quarter aos-animate");
//   product_card.setAttribute("data-aos","");
  product_card.setAttribute("data-product-grid","");
  product_card.setAttribute("data-id",product_id);
  product_card.setAttribute("data-product-id",product_id);
  

  let img_srcset = `
${img_url}_750x.jpg?v=1593537093 750w,
${img_url}_900x.jpg?v=1593537093 900w,
${img_url}_10800x.jpg?v=1593537093 1080w,
`
//   let img_html = `
// <img 
// class="grid-product__image lazyautosizes lazyloaded" 
// data-widths="[750, 900, 1080]" 
// data-aspectratio="0.7499118165784833" 
// data-sizes="auto" 
// alt="${product_name}" 
// data-srcset="${img_srcset}" 
// sizes="270px" 
// srcset="${img_srcset}"
// >
// `
  
  img_url = img_url.replace(/\.jpg\?.*/,"")
  img_url = img_url + "_" + img_width.toString() + "x.jpg?v="
  
  
    let img_html = `
<img 
src="${img_url}${random_version}" 
class="grid-product__image lazyautosizes lazyloaded"
>
`
  
//   console.log(img_srcset)
  
  //the codes below removed from product_card_elements
  // <div class="grid-product__tag__preorder">
  // Same-day Delivery
  // </div>
  
  let product_card_elements = `<div class="grid-product__content">

<a href="/products/${handle}" class="grid-product__link ">
<div class="product-slider" data-image-count="1" data-id=${product_id}>      
<div class="product-slide">
<div class="image-wrap">                
<div class="image-wrap" style="height: 0; padding-bottom: 133.34901223%;">
${img_html}
<noscript>
<img class="grid-product__image lazyloaded"
src="${img_url}_400x.jpg?v=1593537093"
alt="${product_name}">
</noscript>
</div>              
</div>
</div>        
</div>
<div class="grid-product__meta">
<div class="grid-product__title">${product_name}</div>        
<div class="grid-product__price">          
${price_tag}      
</div>
</div>      
</a>

</div>
`

  product_card.innerHTML = product_card_elements
  
  return product_card

}


function FS_product_grid(product_id, product_title, handle, product_img_url, product_price, product_compare_at_price, on_sale, product_turnaround){
  this.id = product_id.toString();
  this.title = product_title;
  this.url = '/products/'+handle;
  this.img_url = product_img_url;
  this.price = product_price;
  this.compare_at_price = product_compare_at_price;

  if (typeof product_turnaround != "undefined"){
    this.turnaround = product_turnaround
  } else {
    this.turnaround = 1
  }
  this.on_sale = on_sale

  // code below for debug
  // if (this.title == 'Serene'){
  //   console.log(this.title + " is on sale = " + this.on_sale)
  // }
  //

  // console.log(this.img_url)
  // this.img_data_src = this.img_url.match(/https:(.*)\.jpg/)[1] + "_{width}x.jpg?v=" + this.img_url.match(/v\=(.*)/)[1]
  let img_version = "?v=8888"
  if (this.img_url.match(/v\=(.*)/)){
    img_version = this.img_url.match(/v\=(.*)/)[1]
  }

  if (this.img_url.match(/https:(.*)(\.jpg|\.webp)/)){
    this.img_data_src = this.img_url.match(/https:(.*)(\.jpg|\.webp)/)[1] + "_{width}x.jpg?v=" + img_version
  } else {
    this.img_data_src = this.img_url + "_{width}x.jpg?v=" + img_version
  }
  /* level 4 ProductGridSlider*/
    /* ProductGridSlider level 4*/
    this.image_container = document.createElement("img")
    this.image_container.classList.add('grid-product__image')
    this.image_container.classList.add('lazyload')
    this.image_container.setAttribute('data-src',this.img_data_src)
    this.image_container.setAttribute('data-widths',"[750, 900, 1080]")
    this.image_container.setAttribute('data-aspectratio',"0.75")
    this.image_container.setAttribute('data-sizes',"auto")
    this.image_container.setAttribute('alt',"")
    /* ProductGridSlider level 4*/

    /* ProductGridSlider level 3*/
    this.image_wrap = document.createElement("div")
    this.image_wrap.classList.add('image-wrap')
    this.image_wrap.setAttribute('style','style="height: 0; padding-bottom: 133.33333333333334%;"')
    /* ProductGridSlider level 3*/

    /* ProductGridSlider level 2*/
    this.product_slide = document.createElement("div")
    this.product_slide.classList.add('product-slide')
    /* ProductGridSlider level 2*/

    /* ProductGridSlider level 1*/
    this.product_grid_slider = document.createElement("div")
    this.product_grid_slider.setAttribute("id", "ProductGridSlider-"+this.id)
    this.product_grid_slider.classList.add('slideshow-wrapper')
    this.product_grid_slider.classList.add('product-slider')
    this.product_grid_slider.setAttribute("data-image-count", "1")
    this.product_grid_slider.setAttribute("data-id", this.id)
    /* ProductGridSlider level 1*/

  this.image_wrap.appendChild(this.image_container)
  this.product_slide.appendChild(this.image_wrap)
  this.product_grid_slider.appendChild(this.product_slide)
  /* level 4 ProductGridSlider*/

  /* level 4 Grid Product Meta*/
    /* Grid Product Meta level 2b */
    this.slashed_price = document.createElement("del")
    this.slashed_price.classList.add('grid-product__price--original')
    this.slashed_price.innerHTML = this.compare_at_price

    this.sale_price = document.createElement("span")
    this.sale_price.classList.add('sale-price')
    this.sale_price.innerHTML = this.price

    this.grid_product_price = document.createElement("div")
    this.grid_product_price.classList.add('grid-product__price')
    /* Grid Product Meta level 2b */

    /* Grid Product Meta level 2a */
    this.grid_product_title = document.createElement("div")
    this.grid_product_title.innerHTML = this.title
    this.grid_product_title.classList.add('grid-product__title')
    /* Grid Product Meta level 2a */

    /* Grid Product Meta level 1 */
    this.grid_product_meta = document.createElement("div")
    this.grid_product_meta.classList.add('grid-product__meta')
    /* Grid Product Meta level 1 */

  if (this.on_sale){
    this.grid_product_price.appendChild(this.slashed_price)
  }
  this.grid_product_price.appendChild(this.sale_price)

  this.grid_product_meta.appendChild(this.grid_product_title)
  this.grid_product_meta.appendChild(this.grid_product_price)
  /* level 4 Grid Product Meta*/

  /* level 3 */
  this.sold_out_tag = document.createElement("div")
  this.sold_out_tag.classList.add("grid-product__tag")
  this.sold_out_tag.classList.add("grid-product__tag--sold-out")
  this.sold_out_tag.innerHTML = "Sold Out"

  this.same_day_tag = document.createElement("div")
  this.same_day_tag.classList.add("grid-product__tag")
  this.same_day_tag.classList.add("grid-product__tag--same-day")
  this.same_day_tag.innerHTML = "Same-day Delivery"

  this.a_container = document.createElement("a")
  this.a_container.setAttribute('href', this.url)
  this.a_container.setAttribute('data-product-id', this.id)
  this.a_container.classList.add('grid-product__link')
  /* level 3 */

  this.a_container.appendChild(this.product_grid_slider)
  this.a_container.appendChild(this.grid_product_meta)
  
  /* level 2 */
  this.product_grid_l2 = document.createElement("div")
  this.product_grid_l2.classList.add("grid-product__content")
  /* level 2 */

  if (this.turnaround == 0){
    this.product_grid_l2.appendChild(this.same_day_tag)
  }

  this.product_grid_l2.appendChild(this.a_container)

  /* level 1 */
  const product_grid_classes = ["grid__item", "grid-product", "small--one-half", "medium-up--one-quarter"]
  this.product_grid = document.createElement("div")
  this.product_grid.setAttribute('data-aos', '')
  this.product_grid.setAttribute('data-product-grid', '')
  this.product_grid.setAttribute('data-id',this.id)

  for (let i=0; i < product_grid_classes.length; i++){
    let product_grid_class = product_grid_classes[i]
    this.product_grid.classList.add(product_grid_class);
  }
  /* level 1 */

  this.product_grid.appendChild(this.product_grid_l2)
  
}